import { action } from 'satcheljs';

/**
 * Action to reset Booking Dashboard Title.
 */
const resetDashboardTitle = action('resetDashboardTitle');

export default resetDashboardTitle;
